import { mapeamentoBandeiras } from '@/types/pagamento';
import cardValidator from 'card-validator';

export default function validarNumeroCartao(numero: string): boolean {
  const validation = cardValidator.number(numero);

  if (!validation.isValid) return false;

  const bandeiraEhAceita = !!mapeamentoBandeiras[validation.card?.type || ''];

  return bandeiraEhAceita;
}
